export default function useAuthHeading() {
  const { t } = useI18n()
  const { authenticationIntent, isSignupVisible } = useSignup()
  const enquiryOwnerName = useEnquiryOwnerName()
  const profileCompletionPending = useProfileCompletionPending()

  const title = computed(() => {
    if (profileCompletionPending.value) {
      return t('auth.profile.title')
    }

    if (isSignupVisible.value) {
      switch (authenticationIntent.value) {
        case 'BookingIntent':
          return t('auth.signup.booking.title')

        case 'EnquiryIntent':
          return t('auth.signup.enquiry.title')

        case 'ListingIntent':
          return t('auth.signup.listing.title')

        default:
          return t('auth.signup.title')
      }
    }

    switch (authenticationIntent.value) {
      case 'BookingIntent':
        return t('auth.login.booking.title')

      case 'EnquiryIntent':
        return t('auth.login.enquiry.title')

      case 'ListingIntent':
        return t('auth.login.listing.title')

      default:
        return t('auth.login.title')
    }
  })

  const subtitle = computed(() => {
    if (profileCompletionPending.value) {
      return t('auth.profile.subtitle')
    }

    const name = enquiryOwnerName.value ?? ''

    if (isSignupVisible.value) {
      switch (authenticationIntent.value) {
        case 'BookingIntent':
          return t('auth.signup.booking.subtitle')

        case 'EnquiryIntent':
          return t('auth.signup.enquiry.subtitle', { name })

        case 'ListingIntent':
          return t('auth.signup.listing.subtitle')

        default:
          return t('auth.signup.subtitle')
      }
    }

    switch (authenticationIntent.value) {
      case 'BookingIntent':
        return t('auth.login.booking.subtitle')

      case 'EnquiryIntent':
        return t('auth.login.enquiry.subtitle', { name })

      case 'ListingIntent':
        return t('auth.login.listing.subtitle')

      default:
        return t('auth.login.subtitle')
    }
  })

  return {
    title,
    subtitle,
  }
}
